export const SET_FEATURED_LISTINGS = "LISTING_SET_FEATURED_LISTINGS";
export const SET_EXTENDED_STAY_LISTINGS = "LISTING_SET_EXTENDED_STAY_LISTINGS";
export const SET_LISTING_LIST = "LISTING_SET_LISTING_LIST";
export const SET_SELECTED_LISTING = "LISTING_SET_SELECTED_LISTING";
export const SET_SELECTED_LISTING_BOOKINGS = "LISTING_SET_SELECTED_LISTING_BOOKINGS";
export const SET_SELECTED_LISTING_CALENDARS = "LISTING_SET_SELECTED_LISTING_CALENDARS";

